import React from 'react';

import PickupOrder from '../../../models/PickupOrder';

import style from './ordersDriver.module.css';
import fdTextLogo from '../../../assets/fd_text_logo.png';

interface DriverDOPOHeaderMobileProps {
  order: PickupOrder;
  type: string;
};

const driverDOPOHeaderMobile = (props: DriverDOPOHeaderMobileProps) => {

  const { order } = props;
  const title: string = props.type === 'po' ? 'Pick Up Order' : 'Drop Off Order';
  return (
    <div className={ style.flex }>

      <div className={ style.headerWrapper }>
        <img className={ style.logoImg } src={ fdTextLogo } alt="frontline dynamics logo"/>
      </div>

      <div>
        <div className={ style.orderTitle }>{ title }</div>
        <div className={ style.orderNumber }>{ props.order.number }</div>
      </div>

      <div className={ [style.headerWrapper, style.headerCompanyInfo].join(' ') }>
        <div>{ order.forwarder_company_name }</div>
        <div >{ order.forwarder_company_info? order.forwarder_company_info.address : '' }</div>
      </div>

    </div> 
  );
}

export default driverDOPOHeaderMobile;